import { GraniteInput } from 'components/V2/Input/GraniteInput';
import { useFieldArray, useFormContext } from 'react-hook-form';
import AddEmailRecipient from 'screens/LetUsHelp/utils/AddEmailRecipient';
import { ContactGroupFormType } from './schema';
import ContactEmailTag from 'components/ContactEmailTag/ContactEmailTag';
import { TokenUserPermissions } from 'api/users/schemas/Users';
import { GraniteLabel } from 'components/V2/Label/GraniteLabel';
import clsx from 'clsx';
import { DisplayForPermission } from 'components/Permission/DisplayForPermission';
import { usePermissions } from 'hooks/usePermissions';

const GroupForm = () => {
  const { hasPermission } = usePermissions({
    permission: [TokenUserPermissions.CONTACT_GROUPS_WRITE],
  });
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<ContactGroupFormType>();

  const {
    append,
    fields: recipients,
    remove,
  } = useFieldArray({
    name: 'recipients',
    control,
  });

  return (
    <div className="flex flex-col gap-6">
      <GraniteInput
        {...register('name')}
        label="Group name"
        placeholder="Group name"
        error={errors.name?.message}
        disabled={!hasPermission}
      />
      <div>
        <DisplayForPermission
          permission={TokenUserPermissions.CONTACT_GROUPS_WRITE}
        >
          <AddEmailRecipient
            appendFunc={append}
            label="Email recipients"
            placeholder="Email address"
            buttonClassName="z-10"
            error={errors.recipients?.message}
          />
        </DisplayForPermission>
        {!hasPermission && <GraniteLabel label="Email recipients" />}
        {recipients.length ? (
          <div
            className={clsx('flex flex-wrap gap-2', hasPermission && 'mt-4')}
          >
            {recipients?.map((recipient, i) => (
              <ContactEmailTag
                key={i}
                index={i}
                email={recipient.email}
                remove={remove}
                {...(!hasPermission && { remove: undefined, disabled: true })}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default GroupForm;
